module.exports = "<div class='main'>\n  <button (click)='switchAbstractOn()'>\n    <span *ngIf='!isAbstractOn'>Show abstract</span>\n    <span *ngIf='isAbstractOn'>Hide abstract</span>\n  </button>\n  <div class='citation'\n    [innerHTML]='dbRecord.shortCitation'></div>\n  <div class='title'>{{dbRecord.title}}</div>\n  <div class='abstract' *ngIf='isAbstractOn'>\n    {{dbRecord.abstract}}\n  </div>\n  <app-note-box [dbRecord]='dbRecord'\n    [topic]='topic'>\n  </app-note-box>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/db-record-topic-box/db-record-topic-box.component.html
// module id = 424
// module chunks = 0